import React from 'react';
import { Popover, PopoverContent, PopoverChevron, PopoverAnchor } from '@fiverr-private/popover';
import { Box } from '@fiverr-private/theme';
import type { TooltipProps } from './types';

const Tooltip = ({
  position = 'top',
  size = 'md',
  appendToBody = false,
  isOpen,
  onOpenChanged,
  content,
  disableFlip = false,
  children,
  as = 'span',
  offset,
  withDelay = true,
  anchorProps,
  dataTrackTag = 'tooltip',
  dataTrackValue,
}: TooltipProps) => (
  <Popover
    triggerEvent="hover"
    isOpen={isOpen}
    position={position}
    onOpenChanged={onOpenChanged}
    disableFlip={disableFlip}
    offset={offset}
  >
    <PopoverAnchor as={as} dataTrackTag="tooltip_anchor" {...anchorProps}>
      {children}
    </PopoverAnchor>
    {content && (
      <PopoverContent
        backgroundColor="grey_1100"
        appendToBody={appendToBody}
        zIndex="tooltip"
        disablePadding
        disableBoxShadow
        borderRadius="lg"
        disableAutoFocus
        withDelay={withDelay}
        dataTrackTag={dataTrackTag}
        dataTrackValue={dataTrackValue}
      >
        <PopoverChevron size="sm" />
        <Box
          color="white"
          maxWidth={256}
          boxSizing="borderBox"
          paddingY={size === 'sm' ? '1.5' : '2.5'}
          paddingX={size === 'sm' ? '2' : '3'}
          fontSize={size === 'sm' ? 'b_xs' : 'b_sm'}
          lineHeight={size === 'sm' ? 'b_xs' : 'b_sm'}
        >
          {content}
        </Box>
      </PopoverContent>
    )}
  </Popover>
);

export default Tooltip;
